<div class="portal-fill portal-flex-center">
    <p class="no-rows-message"
       [translate]="message"></p>
</div>